import { useState, useEffect } from 'react';
import { useWhiteLabel } from '../../context/WhiteLabelContext';
import './scss/BrandLogo.scss';

const BrandLogo = ({
  size = 'medium',
  showText = true,
  className = '',
  onClick,
  style = {},
  useIcon = false,
}) => {
  const { getLogo, getLogoDark, getLogoIcon, getAppName, shouldHideZoobbeBranding, isWhiteLabel } = useWhiteLabel();

  const appName = getAppName();
  const hideZoobbe = shouldHideZoobbeBranding();

  // Detect current theme
  const [isDarkTheme, setIsDarkTheme] = useState(false);

  useEffect(() => {
    // Check if dark theme is active
    const checkTheme = () => {
      const htmlElement = document.documentElement;
      const isDark = htmlElement.classList.contains('dark-theme');
      setIsDarkTheme(isDark);
    };

    // Initial check
    checkTheme();

    // Watch for theme changes
    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    return () => observer.disconnect();
  }, []);

  // decide which asset to use
  const wantIcon = useIcon || !showText; // collapsed sidebar -> icon

  // Get the appropriate logo based on theme
  let logoSrc;
  if (wantIcon) {
    logoSrc = getLogoIcon();
  } else {
    // Use dark logo if dark theme is active and dark logo exists
    const darkLogo = getLogoDark();
    logoSrc = (isDarkTheme && darkLogo) ? darkLogo : getLogo();
  }

  // Size and mode classes
  const sizeClass = `brand-logo--${size}`;
  const modeClass = wantIcon ? 'brand-logo--icon' : '';

  // Combined class names
  const logoClasses = `brand-logo ${sizeClass} ${modeClass} ${className}`.trim();

  // If white label has custom asset, use it
  if (logoSrc) {
    return (
      <div className={logoClasses} onClick={onClick} style={style}>
        <img
          src={logoSrc}
          alt={appName}
          className="brand-logo__image"
        />
        {/* {showText && (
          <span className="brand-logo__text">{appName}</span>
        )} */}
      </div>
    );
  }

  // If white label but no custom logo, show app name only
  if (isWhiteLabel() && hideZoobbe) {
    return (
      <div className={logoClasses} onClick={onClick} style={style}>
        <span className="brand-logo__text brand-logo__text--only">
          {appName}
        </span>
      </div>
    );
  }

  // Default Zoobbe logo
  return (
    <div className={logoClasses} onClick={onClick} style={style}>
      <div className="brand-logo__zoobbe">
        <span className="brand-logo__z">Z</span>
        {showText && (
          <span className="brand-logo__text">oobbe</span>
        )}
      </div>
    </div>
  );
};

export default BrandLogo;
